import { ListManagerFrontendError } from './ListManagerFrontendError';

// When a situation arises where we expect state variables to have certain
// values but don't. Generally means a coding mistake.
export class UnexpectedStateError extends ListManagerFrontendError {
  static errorName = 'UnexpectedStateError';
}
